<template>
    <div
        class="col d-flex flex-row justify-content-between align-items-center p-0 machine-controller"
        style="height: 2rem"
    >
        <div class="d-flex flex-row">
            <div
                @click=" action($action.OPEN_POPUP_CREATE_IMAGE, rentType.NO_FIXED) "
                    class="create-new-image-btn d-flex align-items-center justify-content-center">
                <span style="font-weight: 400; font-size: 0.85rem" >                    
                    <span class="d-none d-md-inline">Create machine</span>
                    <span class="d-inline d-md-none">Create</span>
                </span >
            </div> 
            <el-button
                v-if="selectedNumber > 0"
                @click="action($action.BOOT_IMAGE_MULTI)"
                type="primary"
                size="small"
                class="ml-3"
                round
                >Boot {{ selectedNumber }} image{{
                    selectedNumber === 1 ? "" : "s"
                }}</el-button
            >
        </div>
        <div class="d-flex justify-content-center align-items-center">
            <el-button
                size="small"
                @click="action($action.CLICK_REFRESH_MACHINE_LIST_VIEW)"
                icon="el-icon-refresh-left"
                circle
            ></el-button> 
            <el-input
                size="small"
                clearable
                v-model="machineListRequest.searchString"
                @input="action($action.SEARCH_TYPING_MACHINE_LIST_VIEW)"
                @keyup.enter.native="
                    action($action.SEARCH_TYPING_MACHINE_LIST_VIEW_IMMEDIATELY)
                "
                class="ml-2 d-none d-md-block"
                style="width: 13rem"
                placeholder="Search.."
            >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-select
                @change="action($action.CLICK_REFRESH_MACHINE_LIST_VIEW)"
                v-model="machineListRequest.orderBy"
                size="small"
                placeholder="Order by ..."
                class="ml-2"
                style="width: 8rem"
            >
                <el-option
                    v-for="item in orderByList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
            </el-select>
            <el-radio-group
                @change="action($action.CLICK_REFRESH_MACHINE_LIST_VIEW)"
                v-model="machineListRequest.directionSort"
                class="ml-2 d-none d-md-block"
                size="small"
            >
                <el-radio-button class="m-0" label="ASC" >
                    Ascending
                </el-radio-button>
                <el-radio-button class="m-0" label="DESC" >
                    Descending
                </el-radio-button>
            </el-radio-group> 
            <el-select
                @change="action($action.CLICK_REFRESH_MACHINE_LIST_VIEW)"
                v-model="machineListRequest.directionSort"
                size="small"
                placeholder="Order direction ..."
                class="ml-2 d-block d-md-none"
                style="width: 5rem"
            >
                <el-option label="ASC" value="ASC" > </el-option>
                <el-option label="DESC" value="DESC" > </el-option>
            </el-select>
        </div>
    </div>
</template>

<script>
// Constant
import { POPUP_ID } from "@/constant/baseConstant";
import { MACHINE_LIST_FILTER_BY, RENT_TYPE } from "@/constant/rental";

// Extend
import base from "@/scripts/base";

export default {
    extends: base,

    data() {
        return {
            rentType: RENT_TYPE,

            filterList: [
                {
                    value: MACHINE_LIST_FILTER_BY.ALL,
                    label: "All",
                },
                {
                    value: MACHINE_LIST_FILTER_BY.FIXED_RENTAL,
                    label: "Rental Plan",
                },
            ],

            orderByList: [
                {
                    value: "A.NAME",
                    label: "Name",
                },
                {
                    value: "A.VHDX_LENGTH",
                    label: "Machine size",
                },
                {
                    value: "A.CREATED_AT",
                    label: "Created at",
                },
            ],
        };
    },

    props: {
        selectedNumber: {
            type: Number,
            default: 0,
        },
        machineListRequest: {
            type: Object,
            default() {
                return {};
            },
        },
    },

    methods: {
        // Fixed rental
        handleCommand(command) {
            switch (command) {
                case POPUP_ID.FIXED_RENTAL_EXISTING_MACHINE:
                    this.action(
                        this.$action.OPEN_POPUP_FIXED_RENTAL_EXISTING_MACHINE
                    );
                    break;
                case POPUP_ID.FIXED_RENTAL_CREATE:
                    this.action(
                        this.$action.OPEN_POPUP_CREATE_IMAGE,
                        RENT_TYPE.FIXED_RENTAL
                    );
                    break;
            }
        },

        // Acton
        action(type, data) {
            this.$emit("processingEvent", {
                event: "action",
                data: {
                    type: type,
                    data: data,
                },
            });
        },
    },
};
</script>